import Skeleton from '@mui/material/Skeleton'
import { GridRenderCellParams } from '@mui/x-data-grid'
import { runInAction } from 'mobx'

export default function GapDataGridSkeletonCell<T extends object>(customRenderer?: (params: GridRenderCellParams<T>) => React.ReactNode) {

   return (params: GridRenderCellParams<T>) => {
      if ((params.row as any)?.extraPropIsLoading) {
         return <Skeleton variant="text" width="100%" />
      }

      return customRenderer ? customRenderer(params) : params.value
   }
}

/**
 * Set loading on a given item. We add extraPropIsLoading to the item to indicate loading state
 * @param rows The list of rows shown in the GapDataGrid
 * @param item The item we want to set the loading on
 * @param promise The function it must await before removing the skeleton loading
 */
export const setLoadingOnRow = async <T extends { id: string, extraPropIsLoading?: boolean }>(rows: T[], item: T, promise: () => Promise<void>) => {
   const index = rows.findIndex(r => r.id === item.id)
   if (index === -1) return

   // Set loading to true
   runInAction(() => {
      item.extraPropIsLoading = true
      rows[index] = { ...rows[index], extraPropIsLoading: true }
   })

   // Await the async operation
   await promise()

   // Set loading to false
   runInAction(() => {
      item.extraPropIsLoading = false
      rows[index] = { ...rows[index], extraPropIsLoading: false }
   })
}
